import { render, staticRenderFns } from "./CatalogImportProductShowPopup.vue?vue&type=template&id=5cf804a8"
import script from "./CatalogImportProductShowPopup.vue?vue&type=script&lang=js"
export * from "./CatalogImportProductShowPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports